import { useField } from 'formik';
import React from 'react';
import { eFeePropertyNames, NUMERIC_FEE_VALUES, STRING_FEE_VALUES } from 'types/order/fees/eFeePropertyNames';
import { NumberField, NumberInput } from 'ui-toolkit';
import { IFieldProps } from './IFieldProps';

const cashToCloseNames = ['Cash to Seller', 'Cash to Buyer', 'Cash to Borrower'];

export const Amount: React.FC<IFieldProps> = ({ baseName, readOnly, fee }) => {
  const [{ value }] = useField<string>(`${baseName}.${STRING_FEE_VALUES}.${eFeePropertyNames.BillingPeriod}`);
  //needs a specific exception to make sure a negative amount shows as $0.00
  const negFeeToZero = cashToCloseNames.includes(fee?.stringFeePropertyValues[eFeePropertyNames.Name] || '');

  return (
    <>
      {negFeeToZero && (fee?.numericFeePropertyValues[eFeePropertyNames.Amount] ?? 0) < 0 ? (
        <NumberInput mode={'currency'} value={0} readOnly />
      ) : (
        <NumberField
          name={`${baseName}.${NUMERIC_FEE_VALUES}.${eFeePropertyNames.Amount}`}
          label={'Amount'}
          placeholder={'$0.00'}
          mode={'currency'}
          data-test-id={'fee-detail-amount'}
          readOnly={readOnly || !!value}
        />
      )}
    </>
  );
};
